// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var HhsAuthorizedBy;
(function (HhsAuthorizedBy) {
    HhsAuthorizedBy["Patient"] = "patient";
    HhsAuthorizedBy["Representative"] = "patientRepresentative";
})(HhsAuthorizedBy || (HhsAuthorizedBy = {}));
//# sourceMappingURL=hhsAuthorizedBy.js.map